import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-arvore-hierarquica',
  templateUrl: './arvore-hierarquica.component.html',
  styleUrls: ['./arvore-hierarquica.component.scss']
})
export class ArvoreHierarquicaComponent implements OnChanges {

  @Input() item: any;
  @Input() level: number = 0;

  @Output() expandedChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.item = this.item;

    if(this.item) {
      (this.level === 0)
        ? this.item.expanded = true
        : this.item.expanded = false;
    }
  }

  nomeRazaoSocial(node: any) {
    return node?.nomeRazaoSocial ?? null;
  }

  onChildExpand(expanded: boolean) {
    this.expandedChange.emit(expanded);
  }
}
